import snakeCase from 'lodash-es/snakeCase'

import platform from './platform'

export default (event: string) => ({
  event_text: event,
  event: snakeCase(event),
  platform,
})
